import './monitor'
import { createRoot } from 'react-dom/client'
import App from './App'

//vconsole
if (!['production', 'development'].includes(process.env.ENV as string)) {
  import('vconsole').then((VConsole) => {
    new VConsole.default()
  })
}

window.load$ = new Promise<void>((resolve) => {
  const timeout = setTimeout(() => {
    resolve()
  }, 10000)

  window.addEventListener('load', () => {
    clearTimeout(timeout)
    resolve()
  })
})

Promise.all([
  import(/* webpackMode: "eager" */ './styles/index.scss'),
  import(/* webpackMode: "eager" */ 'dialog-polyfill/dist/dialog-polyfill.css'),
]).then(() => {
  const rootElem = document.getElementById('App')
  if (rootElem) {
    createRoot(rootElem).render(App())
  }
})
